module.exports = __webpack_public_path__ + "img/portada_img_der2.07d52ca5.png";